<template>
  <div>
    <div v-if="mode === 'main'">
      <div class="white-background list-top-margin">
        <!-- 面包屑导航 -->
        <div class="page-top">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>生产管理</el-breadcrumb-item>
            <el-breadcrumb-item>
              <span style="color:#000;font-weight:bold;">报工</span>
            </el-breadcrumb-item>
          </el-breadcrumb>
        </div>

        <!-- tab页 -->
        <div>
          <el-row class="page-row">
            <el-col :span="12">
              <el-tabs v-model="tabName" @tab-click="tabClick">
                <el-tab-pane
                  :label="item.label"
                  :name="item.name"
                  v-for="item in tabList"
                  :key="item.name"
                ></el-tab-pane>
              </el-tabs>
            </el-col>
            <!-- <el-col :span="12" style="text-align:right; padding:5px 5px;">
                <el-button type="primary" size="small" icon="el-icon-check" plain @click="saveCurrent">保存当前</el-button>
                <el-button type="primary" size="small" icon="el-icon-s-operation" @click="filterScheme">筛选方案</el-button>
            </el-col> -->
          </el-row>
        </div>

        <!-- 搜索筛选 -->
        <el-form :model="form" class="user-search" label-width="110px" size="small">
          <el-row>
            <el-col :span="7">
              <el-form-item label="工单编号">
                <el-input size="small" v-model="form.orderCode" placeholder="请输入工单编号" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="产品编号">
                <el-input size="small" v-model="form.productCode" placeholder="请输入产品编号" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="产品名称">
                <el-input size="small" v-model="form.productName" placeholder="请输入产品名称" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3" class="text-align-right">
              <el-button size="small" type="primary" icon="el-icon-search" @click="search">查询</el-button>
            </el-col>
          </el-row>
          <el-row v-show="!isFold" class="search-row">
            <el-col :span="7">
              <el-form-item label="产品规格">
               <el-input size="small" v-model="form.specs" placeholder="请输入产品规格" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="生产人员">
                <el-select
                  v-model="form.producer"
                  clearable
                  multiple
                  filterable
                  placeholder="请选择"
                  style="width:100%;"
                >
                  <el-option
                    v-for="item in producerList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="7">
              <el-form-item label="计划数">
                <div style="display:flex;">
                  <el-input-number
                    class="input-number"
                    v-model="form.planSatrtNum"
                    controls-position="right"
                    :min="1"
                    :max="10"
                    placeholder="最小数"
                  ></el-input-number>
                  <span style="width:12px;text-align:center;">-</span>
                  <el-input-number
                    class="input-number"
                    v-model="form.planEndNum"
                    controls-position="right"
                    :min="1"
                    :max="10"
                    placeholder="最大数"
                  ></el-input-number>
                </div>
              </el-form-item>
            </el-col> -->

            <el-col :span="7" style="clear:both;">
              <el-form-item label="良品数">
                <div style="display:flex;">
                  <el-input-number
                    class="input-number"
                    v-model="form.bestSatrtNum"
                    controls-position="right"
                    :min="0"
                    placeholder="最小数"
                  ></el-input-number>
                  <span style="width:12px;text-align:center;">-</span>
                  <el-input-number
                    class="input-number"
                    v-model="form.bestEndNum"
                    controls-position="right"
                    :min="0"
                    placeholder="最大数"
                  ></el-input-number>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="不良品数">
                <div style="display:flex;">
                  <el-input-number
                    class="input-number"
                    v-model="form.badSatrtNum"
                    controls-position="right"
                    :min="0"
                    placeholder="最小数"
                  ></el-input-number>
                  <span style="width:12px;text-align:center;">-</span>
                  <el-input-number
                    class="input-number"
                    v-model="form.badEndNum"
                    controls-position="right"
                    :min="0"
                    placeholder="最大数"
                  ></el-input-number>
                </div>
              </el-form-item>
            </el-col>


            <el-col :span="7">
              <el-form-item label="工序">
                <el-select
                  v-model="form.processName"
                  clearable
                  multiple
                  filterable
                  placeholder="请选择"
                  style="width:100%;"
                >
                 <el-option
                    v-for="item in processNameList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.label"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="7">
              <el-form-item label="工资单价">
                <div style="display:flex;">
                  <el-input-number
                    class="input-number"
                    v-model="form.unitStartPrice"
                    controls-position="right"
                    :min="0"
                    placeholder="最小数"
                  ></el-input-number>
                  <span style="width:12px;text-align:center;">-</span>
                  <el-input-number
                    class="input-number"
                    v-model="form.unitEndPrice"
                    controls-position="right"
                    :min="0"
                    placeholder="最大数"
                  ></el-input-number>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="预计工资">
                <div style="display:flex;">
                  <el-input-number
                    class="input-number"
                    v-model="form.estimatedStartSalary"
                    controls-position="right"
                    :min="0"
                    placeholder="最小数"
                  ></el-input-number>
                  <span style="width:12px;text-align:center;">-</span>
                  <el-input-number
                    class="input-number"
                    v-model="form.estimatedEndSalary"
                    controls-position="right"
                    :min="0"
                    placeholder="最大数"
                  ></el-input-number>
                </div>
              </el-form-item>
            </el-col>

            <el-col :span="7">
              <el-form-item label="审批时间">
                <el-select
                  v-model="form.aprovalCondition"
                  placeholder="请选择"
                  style="width: 120px;"
                  @change="updateApprovalChange('approvalTime')"
                >
                  <el-option
                    v-for="item in conditionOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <el-date-picker
                  v-if="form.aprovalCondition == 'between'"
                  clearable
                  key="0"
                  class="half-width"
                  v-model="form.approvalTime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :default-time="['00:00:00','23:59:59']"
                ></el-date-picker>
                <el-date-picker
                  v-if="form.aprovalCondition !== 'between' && form.aprovalCondition !== 'auto'"
                  key="1"
                  class="half-width"
                  v-model="form.approvalTime"
                  type="datetime"
                  placeholder="请选择日期"
                  value-format="yyyy-MM-dd HH:mm:ss"
                ></el-date-picker>
                <el-select
                  v-model="form.approvalTime"
                  placeholder="请选择"
                  v-if="form.aprovalCondition == 'auto'"
                  class="half-width"
                  :class="{'w120':form.approvalValue == '7'}"
                  @change="dynamicUpdateValueChange"
                >
                  <el-option
                    v-for="item in dynamicDate"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <el-select
                  v-model="form.approvalTime"
                  placeholder="请选择"
                  v-if="form.aprovalCondition == 'auto' && form.approvalValue == '7'"
                  style="margin-top: 8px;width: 120px;"
                >
                  <el-option
                    v-for="item in dateOneOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <el-tooltip content="只支持1-365的正整数">
                  <el-input-number
                    v-if="form.aprovalCondition == 'auto' && form.approvalValue == '7'"
                    @blur="dateInputUpdateBlur"
                    v-model="form.approvalTime"
                    step-strictly
                    controls-position="right"
                    :min="1"
                    :max="365"
                    style="margin-left: 8px;margin-top: 8px;width: 120px;"
                  ></el-input-number>
                </el-tooltip>
                <el-select
                  v-model="form.approvalTime"
                  placeholder="请选择"
                  v-if="form.aprovalCondition == 'auto'&& form.approvalValue == '7'"
                  style="margin-left: 8px;margin-top: 8px;width: calc(100% - 264px);"
                >
                  <el-option
                    v-for="item in dateTwoOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="审批人">
                <el-select
                  v-model="form.approver"
                  clearable
                  multiple
                  filterable
                  placeholder="请选择"
                  style="width:100%;"
                >
                <el-option
                    v-for="item in producerList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.label"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="审批状态">
                <el-select
                  v-model="form.approveStatus"
                  clearable
                  filterable
                  placeholder="请选择"
                  style="width:100%;"
                >
                <el-option
                    v-for="item in approveStatusList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.label"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="7">
              <el-form-item label="计价方式">
                <el-select
                  v-model="form.countType"
                  clearable
                  multiple
                  filterable
                  placeholder="请选择"
                  style="width:100%;"
                >
                <el-option
                    v-for="item in countTypeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="创建人">
                <el-select
                  v-model="form.creater"
                  clearable
                  multiple
                  filterable
                  placeholder="请选择"
                  style="width:100%;"
                >
                <el-option
                    v-for="item in producerList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.label"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="创建时间">
                <el-select
                  v-model="form.createCondition1"
                  placeholder="请选择"
                  style="width: 120px;"
                  @change="createConditionChange('createTime')"
                >
                  <el-option
                    v-for="item in conditionOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <el-date-picker
                  v-if="form.createCondition1 == 'between'"
                  key="0"
                  class="half-width"
                  v-model="form.createTime"
                  type="daterange"
                  range-separator="至"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :default-time="['00:00:00','23:59:59']"
                ></el-date-picker>
                <el-date-picker
                  v-if="form.createCondition1 !== 'between' && form.createCondition1 !== 'auto'"
                  class="half-width"
                  v-model="form.createTime"
                  type="datetime"
                  placeholder="请选择日期"
                  value-format="yyyy-MM-dd HH:mm:ss"
                ></el-date-picker>
                <el-select
                  v-model="form.createTime"
                  placeholder="请选择"
                  v-if="form.createCondition1 == 'auto'"
                  class="half-width"
                  :class="{'w120':form.dynamicCreateValue == '7'}"
                  @change="dynamicCreateValueChange"
                >
                  <el-option
                    v-for="item in dynamicDate"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <el-select
                  v-model="form.createTime"
                  placeholder="请选择"
                  v-if="form.createCondition1 == 'auto' && form.dynamicCreateValue == '7'"
                  style="margin-top: 8px;width: 120px;"
                >
                  <el-option
                    v-for="item in dateOneOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <el-tooltip content="只支持1-365的正整数">
                  <el-input-number
                    v-if="form.createCondition1 == 'auto' && form.dynamicCreateValue == '7'"
                    @blur="dateInputCreateBlur"
                    v-model="form.createTime"
                    step-strictly
                    controls-position="right"
                    :min="1"
                    :max="365"
                    style="margin-left: 8px;margin-top: 8px;width: 120px;"
                  ></el-input-number>
                </el-tooltip>
                <el-select
                  v-model="form.createTime"
                  placeholder="请选择"
                  v-if="form.createCondition1 == 'auto' && form.dynamicCreateValue == '7'"
                  style="margin-left: 8px;margin-top: 8px;width: calc(100% - 264px);"
                >
                  <el-option
                    v-for="item in dateTwoOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="7">
              <el-form-item label="更新人">
                <el-select
                  v-model="form.updater"
                  clearable
                  multiple
                  filterable
                  placeholder="请选择"
                  style="width:100%;"
                >
                  <el-option
                    v-for="item in producerList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.label"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="更新时间">
                <el-select
                  v-model="form.updateCondition1"
                  placeholder="请选择"
                  style="width: 120px;"
                  @change="updateConditionChange('updateTime')"
                >
                  <el-option
                    v-for="item in conditionOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <el-date-picker
                  v-if="form.updateCondition1 == 'between'"
                  key="0"
                  class="half-width"
                  v-model="form.updateTime"
                  type="daterange"
                  range-separator="至"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :default-time="['00:00:00','23:59:59']"
                ></el-date-picker>
                <el-date-picker
                  v-if="form.updateCondition1 !== 'between' && form.updateCondition1 !== 'auto'"
                  key="1"
                  class="half-width"
                  v-model="form.updateTime"
                  type="datetime"
                  placeholder="请选择日期"
                  value-format="yyyy-MM-dd HH:mm:ss"
                ></el-date-picker>
                <el-select
                  v-model="form.updateTime"
                  placeholder="请选择"
                  v-if="form.updateCondition1 == 'auto'"
                  class="half-width"
                  :class="{'w120':form.dynamicUpdateValue == '7'}"
                  @change="dynamicUpdateValueChange"
                >
                  <el-option
                    v-for="item in dynamicDate"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <el-select
                  v-model="form.updateTime"
                  placeholder="请选择"
                  v-if="form.updateCondition1 == 'auto' && form.dynamicUpdateValue == '7'"
                  style="margin-top: 8px;width: 120px;"
                >
                  <el-option
                    v-for="item in dateOneOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <el-tooltip content="只支持1-365的正整数">
                  <el-input-number
                    v-if="form.updateCondition1 == 'auto' && form.dynamicUpdateValue == '7'"
                    @blur="dateInputUpdateBlur"
                    v-model="form.updateTime"
                    step-strictly
                    controls-position="right"
                    :min="1"
                    :max="365"
                    style="margin-left: 8px;margin-top: 8px;width: 120px;"
                  ></el-input-number>
                </el-tooltip>
                <el-select
                  v-model="form.updateTime"
                  placeholder="请选择"
                  v-if="form.updateCondition1 == 'auto'&& form.dynamicUpdateValue == '7'"
                  style="margin-left: 8px;margin-top: 8px;width: calc(100% - 264px);"
                >
                  <el-option
                    v-for="item in dateTwoOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-divider>
            <i :class="!isFold?'el-icon-caret-top':'el-icon-caret-bottom'" @click="fold"></i>
          </el-divider>
        </el-form>
      </div>
      <div class="white-background">
        <el-row class="tbl-btn">
          <el-col :span="12" class="tbl-btn-left">
            <el-button type="primary" icon="el-icon-circle-plus-outline" size="small" @click='crateReport'>创建报工</el-button>
            <el-dropdown class="left-default-margin right-default-margin" @command="handleCommand" trigger="click">
              <el-button type="primary" size="small" plain icon="el-icon-s-operation">批量操作</el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="delete"><i class="el-icon-delete"></i>批量删除</el-dropdown-item>
                <el-dropdown-item command="approval"><i class="el-icon-s-promotion"></i>批量审批</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

            <!-- <el-button type="text" icon="el-icon-circle-plus-outline" @click="addTemplate">新增打印模板</el-button>
            <el-button type="text" icon="el-icon-edit-outline" @click="saveTemplate">编辑打印模板</el-button> -->

            <el-button size="small" type="primary" plain icon="el-icon-download" @click="templateDownload">模板下载</el-button>
            <el-button size="small" type="success" plain icon="el-icon-upload2" @click="importData">导入</el-button>
            <el-button size="small" type="success" plain icon="el-icon-s-promotion" @click="exportDataNew">导出</el-button>

            <!-- <el-button type="text" icon="el-icon-document"  @click='showImportLog'>查看导入日志</el-button> -->
            <el-upload  ref="workReportImp" name="workReportImp" :action="action()" :on-change="
                (file, fileList) => {
                handleChange(file, fileList);
                }
            "
              :auto-upload="false" :show-file-list="false" accept=".xlsx" v-show="false">

            </el-upload>
          </el-col>
          <!-- <el-col :span="12" class="tbl-btn-right">
            <el-button type="primary" size="small" icon="el-icon-tickets">操作记录</el-button>
            <el-button type="default" size="small" icon="el-icon-s-operation">列配置</el-button>
          </el-col> -->
        </el-row>
        <!--列表-->
        <el-table
          ref="tableData"
          size="small"
          :data="listData"
          highlight-current-row
          v-loading="loading"
          :header-cell-style="_headerStyle"
          stripe
          border
          element-loading-text="加载中"
          style="width: 100%;"
          row-key="_id"
          @selection-change="handleTblSelectionChange"
        >
          <el-table-column align="left" type="selection" :reserve-selection="true" width="60"></el-table-column>
          <el-table-column align="left" type="index" width="50" label="序号"></el-table-column>
          <el-table-column prop="orderCode" label="工单编号" width="170">
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.baseInfo.orderCode" placement="top">
                <span class="txt-overflow">{{scope.row.baseInfo.orderCode}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="产品编号" width="170">
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.enterProduct.productCode" placement="top">
                <span class="txt-overflow">{{scope.row.enterProduct.productCode}}</span>
              </el-tooltip>
            </template>
          </el-table-column>

          <el-table-column label="产品名称" width="150">
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.enterProduct.productName" placement="top">
                <span class="txt-overflow">{{scope.row.enterProduct.productName}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="specs" label="产品规格" width="130">
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.enterProduct.specs" placement="top">
                <span class="txt-overflow">{{scope.row.enterProduct.specs}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="processName" label="工序名称" width="90">
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.enterProcess.processName" placement="top">
                <span class="txt-overflow">{{scope.row.enterProcess.processName}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="taskStatus" label="工序状态" width="90">
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.baseInfo.taskStatus" placement="top">
                <span class="txt-overflow">{{scope.row.baseInfo.taskStatus}}</span>
              </el-tooltip>
            </template>
          </el-table-column> -->
          <el-table-column prop="countNum" label="报工数量" width="90">
            <template slot-scope="scope">
              <span class="txt-overflow">{{scope.row.baseInfo.countNum}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="goodNum" label="良品数量" width="100">
            <template slot-scope="scope">
              <span class="txt-overflow">{{scope.row.baseInfo.goodNum}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="nongoodNum" label="不良品数量" width="100">
            <template slot-scope="scope">
              <span class="txt-overflow">{{scope.row.baseInfo.nongoodNum}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="countType" label="计价方式" width="100">
            <template slot-scope="scope">
              <span class="txt-overflow">{{scope.row.performanceInfo.countType}}</span>
            </template>
          </el-table-column>

          <el-table-column prop="salaryUnit" label="工资单价" width="100">
            <template slot-scope="scope">
              <span class="txt-overflow">{{scope.row.performanceInfo.salaryUnit}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="estimateSalary" label="预计工资" width="100">
            <template slot-scope="scope">
              <span class="txt-overflow">{{scope.row.performanceInfo.estimateSalary}}</span>
            </template>
          </el-table-column>

          <!-- <el-table-column prop="unit" label="单位" width="100">
            <template slot-scope="scope">
              <span class="txt-overflow">{{scope.row.baseInfo.unit}}</span>
            </template>
          </el-table-column> -->
          <el-table-column prop="producer" label="生产人员" width="130" >
            <template slot-scope="scope">
              <span v-if="scope.row.baseInfo && scope.row.baseInfo.producer && scope.row.baseInfo.producer.id">{{[scope.row.baseInfo.producer.id] | transfer(producerList)}}</span>
              <span v-if="scope.row.baseInfo && scope.row.baseInfo.producer && scope.row.baseInfo.producer._id">{{[scope.row.baseInfo.producer._id] | transfer(producerList)}}</span>

              <!-- <span class="txt-overflow">{{scope.row.baseInfo && scope.row.baseInfo.producer ?scope.row.baseInfo.producer.name :'' }}</span> -->
              <!-- <span class="txt-overflow">{{scope.row.baseInfo && scope.row.baseInfo.producer ?([scope.row.baseInfo.producer.id] | transfer(producerList)) :'' }}</span> -->
            </template>
          </el-table-column>
          <!-- <el-table-column prop="startTime" label="报工开始时间" width="140">
            <template slot-scope="scope">
              <span class="txt-overflow">{{scope.row.baseInfo.timeRange?scope.row.baseInfo.timeRange[0]:""}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="endTime" label="报工结束时间" width="140">
            <template slot-scope="scope">
              <span class="txt-overflow">{{scope.row.baseInfo.timeRange?scope.row.baseInfo.timeRange[1]:""}}</span>
            </template>
          </el-table-column> -->
          <!-- <el-table-column prop="duration" label="报工时长" width="100">
            <template slot-scope="scope">
              <span class="txt-overflow">{{scope.row.baseInfo.durationHours + "时" + scope.row.baseInfo.durationMin+"分"}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="standardEff" label="标准效率" width="100">
            <template slot-scope="scope">
              <span class="txt-overflow">{{scope.row.baseInfo.standardEff}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="actualEff" label="实际效率" width="100">
            <template slot-scope="scope">
              <span class="txt-overflow">{{scope.row.baseInfo.actualEff}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="achievement" label="达标率" width="100">
            <template slot-scope="scope">
              <span class="txt-overflow">{{scope.row.baseInfo.achievement}}</span>
            </template>
          </el-table-column> -->
          <el-table-column prop="approveStatus" label="审批状态" width="100">
            <template slot-scope="scope">
              <span class="txt-overflow">{{scope.row.performanceInfo?scope.row.performanceInfo.approveStatus:""}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="approver" label="审批人" width="130">
            <template slot-scope="scope">
              <span class="txt-overflow">{{scope.row.performanceInfo?scope.row.performanceInfo.approver:""}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="approveTime" label="审批时间" width="140">
            <template slot-scope="scope">
              <span class="txt-overflow">{{scope.row.performanceInfo?scope.row.performanceInfo.approveTime:""}}</span>
            </template>
          </el-table-column>



          <el-table-column v-for="item in setList" :key="item._id" :prop="item.fieldName" :label="item.fieldName">
            <template slot-scope="scope">
              <span class="txt-overflow">{{scope.row.baseInfo?scope.row.baseInfo[item.fieldName]:""}}</span>
            </template>
          </el-table-column>

          <el-table-column prop="creater" label="创建人" width="130">
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" width="140"></el-table-column>
          <el-table-column prop="updater" label="更新人" width="130"></el-table-column>
          <el-table-column prop="updateTime" label="更新时间" width="140"></el-table-column>

          <el-table-column align="left" label="操作" min-width="190" fixed="right">
            <template slot-scope="scope">
              <!-- <el-tooltip content="查看">
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-view"
                  circle
                  @click="handleShow(scope.$index, scope.row)"
                ></el-button>
              </el-tooltip> -->
              <el-tooltip content="编辑">
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-edit"
                  circle
                  @click="handleEdit(scope.$index, scope.row)"
                  :disabled="scope.row.enterOrder.orderStatus != '执行中'"
                ></el-button>
              </el-tooltip>
              <!-- <el-tooltip content="打印">
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-printer"
                  circle
                  @click="handlePrint(scope.$index, scope.row)"
                ></el-button>
              </el-tooltip> -->
              <el-tooltip content="删除">
                <el-button
                  size="mini"
                  type="danger"
                  icon="el-icon-delete"
                  circle
                  @click="handleDelete(scope.$index, scope.row)"
                ></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather" class="tbl-pagination"></Pagination>
      </div>
    </div>
    <CreateReport v-if="mode === 'other'" :mode="mode" :userData="userData" @done="done" @goBack="goBack" :setList="setList" :editRow="editRow" :modelStatus="modelStatus"></CreateReport>
    <SaveScheme :diaVisible="schemeVisible"></SaveScheme>
    <FilterScheme :diaVisible="filterSchemeVisible"  :listData="tabList" @filterRefresh="filterRefresh"></FilterScheme>
    <ImportLog v-if="mode === 'log'" @goBack="goBack"></ImportLog>

    <el-dialog
     title="打印"
     :visible.sync="printVisible"
     width="900px"
    :show-close="true"
    :modal-append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    @close="done"
    >
    <print-layout v-if="printVisible" :userData="userData"  :editRow="editRow"  :type="'enter'" :userList="[]" @done="done"></print-layout>
    </el-dialog>

    <el-dialog
     :title="templateTitle"
     :visible.sync="printTemplateVisible"
     width="900px"
    :show-close="true"
    :modal-append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    @close="done"
    >
    <print-template v-if="printTemplateVisible" :userData="userData"  :editRow="editRow" :type="'enter'"  :userList="[]" @done="done"></print-template>
    </el-dialog>
  </div>
</template>
<script>
import moment from 'moment';
import { enterGetList,enterDelete ,enterBatchDelete,processGetAll} from '@/api/basicData';
import { queryAllCustomSet,queryAllUserList,reportTempDownLoad,reportBatchImp,exportExcel,reportBatchApproval} from '@/api/business';
import Pagination from "../../components/Pagination";
import SaveScheme from "../../components/SaveScheme";
import FilterScheme from "../../components/FilterScheme";
import CreateReport from "./CreateReport.vue";
import ImportLog from "./ImportLog.vue";
import PrintLayout from "@/views/task/PrintLayout";
import PrintTemplate from "@/views/task/PrintTemplate";
import {exportDataToExcel,transfer} from '@/utils/util';

export default {
  name: "Report",
  components: {
    Pagination,
    SaveScheme,
    FilterScheme,
    CreateReport,
    ImportLog,
    PrintLayout,
    PrintTemplate
  },
  data() {
    return {
      templateTitle:'新增打印模板',
      printTemplateVisible:false,
      printVisible:false,
      mode: 'main',  // 页面主要内容
      filterSchemeVisible:false,
      schemeVisible:false,
      isBatchPrint: false,
      importLogVisible: false,
      form: {
        factoryId:'',
      },
      listData: [],
      loading: false,
      isFold: true,
      tblSelectionList: [],
      processNameList: [],
      approvalStatusLIst: [{
          label: "已审批",
          value: "0"
        },
        {
          label: "未审批",
          value: "1"
        },],
      countTypeList: [{
          label: "计件",
          value: "计件"
        },
        {
          label: "计时",
          value: "计时"
      },],
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      tabList: [
        {
          label: "全部",
          color:'#000',
          name: "0"
        },
      ],
      tabName: "0",
      conditionOptions: [
        {
          value: "between",
          label: "选择范围"
        },
        {
          value: "lt",
          label: "小于"
        },
        {
          value: "lte",
          label: "小于等于"
        },
        {
          value: "eq",
          label: "等于"
        },
        {
          value: "gt",
          label: "大于"
        },
        {
          value: "gte",
          label: "大于等于"
        }
      ],
      dynamicDate: [
        {
          value: "0",
          label: "今天"
        },
        {
          value: "1",
          label: "昨天"
        },
        {
          value: "2",
          label: "本周"
        },
        {
          value: "3",
          label: "上周"
        },
        {
          value: "4",
          label: "本月"
        },
        {
          value: "5",
          label: "上月"
        },
        {
          value: "6",
          label: "近三月"
        },
        {
          value: "7",
          label: "自定义"
        }
      ],
      dateOneOptions: [
        {
          value: "过去",
          label: "过去"
        },
        {
          value: "未来",
          label: "未来"
        }
      ],
      dateTwoOptions: [
        {
          value: "日",
          label: "日"
        },
        {
          value: "周",
          label: "周"
        },
        {
          value: "月",
          label: "月"
        },
        {
          value: "季度",
          label: "季度"
        },
        {
          value: "年",
          label: "年"
        }
      ],
      userData:{},
      editRow:{},
      modelStatus:'',
      producerList:[],
      taskStatusList:[
        {
          label: "未开始",
          value: "未开始"
        },
        {
          label: "执行中",
          value: "执行中"
        },
        {
          label: "已结束",
          value: "已结束"
        }
      ],
      approveStatusList:[
        {
          label:'未审批',
          value:'0'
        },
        {
          label:'已审批',
          value:'1'
        }
      ],
      setList:[],

    };
  },
  created() {
    var userData = window.localStorage.getItem('userdata')
    if(userData){
      this.userData = JSON.parse(userData);
      this.form['factoryId'] = this.userData.factoryId;

      this.init();
    }
  },
  methods: {
    //导出数据前对数据处理，变为想要的格式。
    filterTableData(data) {
      data.forEach((item) => {
        item.orderCode = item.baseInfo? item.baseInfo.orderCode:'';

        item.productCode = item.baseInfo? item.baseInfo.productCode:'';
        item.productName = item.baseInfo? item.enterProduct.productName:'';
        item.specs = item.baseInfo? item.enterProduct.specs:'';
        item.processName = item.baseInfo? item.enterProcess.processName:'';
        item.countNum = item.baseInfo? item.baseInfo.countNum:'';
        item.countType = item.performanceInfo? item.performanceInfo.countType:'';
        item.salaryUnit = item.performanceInfo? item.performanceInfo.salaryUnit:'';
        item.estimateSalary = item.performanceInfo? item.performanceInfo.estimateSalary:'';

        item.goodNum = item.baseInfo? item.baseInfo.goodNum:'';
        item.nongoodNum = item.baseInfo? item.baseInfo.nongoodNum:'';
        item.producer = item.baseInfo?transfer([item.baseInfo.producer.id],this.producerList):'';

        item.approveStatus = item.performanceInfo? item.performanceInfo.approveStatus:'';
        item.approver = item.performanceInfo? item.performanceInfo.approver:'';
        item.approveTime = item.performanceInfo? item.performanceInfo.approveTime:'';

        for(let i = 0;i<this.setList.length;i++){
          item[this.setList[i]['fieldName']] = item.baseInfo[this.setList[i]['fieldName']];
        }

      });
      return data;
    },
    exportDataNew(){
      if(this.tblSelectionList == null || this.tblSelectionList.length == 0){
        this.exportData();

        return;
      }
      const header = [
        "工单编号",
        '产品编号',
        '产品名称',
        '产品规格',
        '工序名称',
        '计价方式',
        '工资单价',
        '预计工资',
        '报工数量',
        '良品数量',
        '不良品数量',
        '生产人员',
        '审批状态',
        '审批时间',
        '审批人',

        '创建人',
        '创建时间',
        '更新人',
        '更新时间',


      ];
      const filterVal = [
        'orderCode',
        'productCode',
        'productName',
        'specs',
        'processName',
        'countType',
        'salaryUnit',
        'estimateSalary',
        'countNum',
        'goodNum',
        'nongoodNum',
        'producer',
        'approveStatus',
        'approveTime',
        'approver',
        'creater',
        'createTime',
        'updater',
        'updateTime',

      ];
      for(let k = 0;k<this.setList.length;k++){
        header.push(this.setList[k]['fieldName']);
        filterVal.push(this.setList[k]['fieldName']);
      }
      let filterData =this.filterTableData(JSON.parse(JSON.stringify(this.tblSelectionList)));
      let data = filterData.map(v => filterVal.map(j => v[j]));
      exportDataToExcel(data,header,"报工清册"+Date.now());
    },
    exportData(){
       var enterStartTime = {};
      var enterEndTime = {};
      var approveTime = {};
      var createTime = {};
      var updateTime = {};
      if(this.form.startTime){

        if(this.form.createCondition == "between" && this.form.startTime.length == 2){
          enterStartTime = {
            begin:this.form.startTime?this.form.startTime[0]:'',
            end:this.form.startTime?this.form.startTime[1]:'',
            type:this.form.createCondition,
            data:'time'

          }
        }else{
          enterStartTime = {
            type:this.form.createCondition,
            value:this.form.startTime,
            data:'time'
          }
        }
      }
      if(this.form.endTime){
        if(this.form.updateCondition == "between" && this.form.endTime.length == 2){
          enterEndTime = {
            begin:this.form.endTime[0],
            end:this.form.endTime[1],
            type:this.form.updateCondition,
            data:'time'

          }
        }else{
          enterEndTime = {
            type:this.form.updateCondition,
            value:this.form.endTime,
            data:'time'
          }
        }
      }
      if(this.form.approvalTime){
        if(this.form.aprovalCondition == "between" && this.form.approvalTime.length == 2){
          approveTime = {
            begin:this.form.approvalTime[0],
            end:this.form.approvalTime[1],
            type:this.form.aprovalCondition,
            data:'time'
          }
        }else{
          approveTime = {
            type:this.form.aprovalCondition,
            value:this.form.approvalTime,
            data:'time'
          }
        }
      }
      if(this.form.createTime){
        if(this.form.createCondition1 == "between" && this.form.createTime.length == 2){
          createTime = {
            begin:this.form.createTime[0],
            end:this.form.createTime[1],
            type:this.form.createCondition1,
            data:'time'
          }
        }else{
          createTime = {
            type:this.form.createCondition1,
            value:this.form.createTime,
            data:'time'
          }
        }
      }
      if(this.form.updateTime){
        if(this.form.updateCondition1 == "between" && this.form.updateTime.length == 2){
          updateTime = {
            begin:this.form.updateTime[0],
            end:this.form.updateTime[1],
            type:this.form.updateCondition1,
            data:'time'
          }
        }else{
          updateTime = {
            type:this.form.updateCondition1,
            value:this.form.updateTime,
            data:'time'
          }
        }
      }
      var params = {
        condition: {
          'factoryId': this.userData.factoryId,
          'performanceInfo.approveStatus':this.form.approveStatus,
          'baseInfo.orderCode':this.form.orderCode,
          'baseInfo.productCode':this.form.productCode,
          'enterProduct.productName':this.form.productName,
          'baseInfo.processCode':this.form.processCode,
          'enterProduct.specs':this.form.specs,
          // orderStatus:this.form.taskStatus,//搞清楚工序状态到底是工序还是任务状态
        },
        tableName:'报工',
        collection:'enter',
      }
      if(this.form.processName && this.form.processName.length!=0){
        params.condition['enterProcess.processName'] = this.form.processName
      }
      if(this.form.creater && this.form.creater.length!=0){
        params.condition.creater = this.form.creater
      }
      if(this.form.updater && this.form.updater.length!=0){
        params.condition.updater = this.form.updater
      }
      if(JSON.stringify(createTime)!='{}'){
        params.condition.createTime = createTime
      }
      if(JSON.stringify(updateTime)!='{}'){
        params.condition.updateTime = updateTime
      }
      if(this.form.producer && this.form.producer.length!=0){
        params.condition['baseInfo.producer.id'] = this.form.producer;
      }
      if(this.form.approver && this.form.approver.length!=0){
        params.condition['performanceInfo.approver'] = this.form.approver
      }
      if(this.form.countType && this.form.countType.length!=0){
        params.condition['performanceInfo.countType'] = this.form.countType
      }

      if(JSON.stringify(approveTime)!='{}'){
        params.condition['performanceInfo.approveTime'] = approveTime
      }
      if(JSON.stringify(enterStartTime)!='{}'){
        params.condition.enterStartTime = enterStartTime
      }
      if(JSON.stringify(enterEndTime)!='{}'){
        params.condition.enterEndTime = enterEndTime
      }

      if(this.form.planSatrtNum || this.form.planEndNum){
        params.condition.planNum = {
          begin:this.form.planSatrtNum,
          end:this.form.planEndNum,
          type:'between',
          data:'num'
        }
      }
      if(this.form.bestSatrtNum || this.form.bestEndNum){
        params.condition['baseInfo.goodNum'] = {
          begin:this.form.bestSatrtNum,
          end:this.form.bestEndNum,
          type:'between',
          data:'num'
        };
      }
      if(this.form.badSatrtNum || this.form.badEndNum){
        params.condition['baseInfo.nongoodNum'] = {
          begin:this.form.badSatrtNum,
          end:this.form.badEndNum,
          type:'between',
          data:'num'
        }
      }
      if(this.form.unitStartPrice || this.form.unitEndPrice){
        params.condition['performanceInfo.salaryUnit'] = {
          begin:this.form.unitStartPrice,
          end:this.form.unitEndPrice,
          type:'between',
          data:'num'
        }
      }

      if(this.form.estimatedStartSalary || this.form.estimatedEndSalary){
        params.condition['performanceInfo.estimateSalary'] = {
          begin:this.form.estimatedStartSalary,
          end:this.form.estimatedEndSalary,
          type:'between',
          data:'num'
        }
      }
      // var approveTime = this.formateType(this.form.approvalTime)

      // if(JSON.stringify(approveTime)!='{}'){
      //   params.condition.approveTime = approveTime
      // }
      var x = new XMLHttpRequest();
      var self = this;
      let url = this.$devEnv.API_ROOT + '/api/exportExcel';
      x.open("POST", url, true);
      x.responseType = 'blob';
      x.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      x.onload=function(e) {
          if (x.readyState === x.DONE) {
              if (x.status === 200) {
                  //会创建一个 DOMString，其中包含一个表示参数中给出的对象的URL。这个 URL 的生命周期和创建它的窗口中的 document 绑定。这个新的URL 对象表示指定的 File 对象或 Blob 对象。
                  var url = window.URL.createObjectURL(x.response)
                  var a = document.createElement('a');
                  a.href = url
                  a.download = "报工清册.xlsx";
                  a.click()
              }else {
                  self.$message({
                      type: 'error',
                      message: '下载失败',
                  });
              }
          }else {
              self.$message({
                  type: 'error',
                  message: '下载失败',
              });
          }
      }
      x.send(JSON.stringify(params));

      // exportExcel(params).then(res=>{

      // })
    },
    formatApproveStatus(val){
      if(val!==undefined){
        var res = this.approveStatusList.filter(function(item){return item.value == val})
        if(res && res.length!=0){
          return res[0].label
        }
      }
      return ''
    },
    handlePrint(index,row){
      this.editRow = row;
      this.printVisible = true;
    },
    addTemplate(){
      this.templateTitle = "新增打印模板"
      this.editRow = null;
      this.printTemplateVisible = true;
    },
    saveTemplate(){
      this.templateTitle = "编辑打印模板"
      this.editRow = this.listData[0];
      this.printTemplateVisible = true;


    },
    handleChange(file, fileList){
        let data = new FormData();

        data.append("file", file.raw);
        data.append("factoryId ", this.userData.factoryId);
        data.append("creater",this.userData.name + "(" + this.userData.account + ")");
        reportBatchImp(data).then(res=>{
          this.getdata();

        });

    },
    action(){
      return this.$devEnv.API_ROOT + `/enter/importData`;
    },
    templateDownload(){
      var x = new XMLHttpRequest();
      var self = this;
      let url = this.$devEnv.API_ROOT + '/enter/downloadTemplate';
      x.open("GET", url, true);
      x.responseType = 'blob';
      x.onload=function(e) {
          if (x.readyState === x.DONE) {
              if (x.status === 200) {
                  //会创建一个 DOMString，其中包含一个表示参数中给出的对象的URL。这个 URL 的生命周期和创建它的窗口中的 document 绑定。这个新的URL 对象表示指定的 File 对象或 Blob 对象。
                  var url = window.URL.createObjectURL(x.response)
                  var a = document.createElement('a');
                  a.href = url
                  a.download = "报工导入模板.xlsx";
                  a.click()
              }else {
                  self.$message({
                      type: 'error',
                      message: '下载失败',
                  });
              }
          }else {
              self.$message({
                  type: 'error',
                  message: '下载失败',
              });
          }
      }
      x.send();
      // reportTempDownLoad().then(res=>{
      //     var url = window.URL.createObjectURL(res);
      //     var a = document.createElement('a');
      //     a.href = url;
      //     a.download = "报工导入模板" + ".xlsx";
      //     a.click()
      // });
    },
    importData(){
      this.$refs["workReportImp"].$refs['upload-inner'].handleClick();
    },

    async init(){
      let res = await processGetAll(this.userData.factoryId);
      if(res['code'] == 200){
        this.processNameList = res.data.map(function(item){
          return {
            label:item.processName,
            value:item.processCode
          }
        })
      }
      res = await queryAllUserList(this.userData.factoryId);
      if(res['code'] == 200){
        this.producerList = res.data.map(function(item){
          return {
            label:item.name + '(' + item.account + ')',
            value:item._id
          }
        });

      }
      queryAllCustomSet(this.userData.factoryId,'enter').then(res=>{
        this.setList = [];
        if(res['code'] == 200){
          this.setList = res['data'];
          this.getdata();
        }
      });
    },
    search(){
      this.pageparm.currentPage = 1;
      this.pageparm.pageSize = 10;
      this.getdata();
    },
    getdata() {
      this.loading = true;
      var enterStartTime = {};
      var enterEndTime = {};
      var approveTime = {};
      var createTime = {};
      var updateTime = {};
      if(this.form.startTime){

        if(this.form.createCondition == "between" && this.form.startTime.length == 2){
          enterStartTime = {
            begin:this.form.startTime?this.form.startTime[0]:'',
            end:this.form.startTime?this.form.startTime[1]:'',
            type:this.form.createCondition,
            data:'time'

          }
        }else{
          enterStartTime = {
            type:this.form.createCondition,
            value:this.form.startTime,
            data:'time'
          }
        }
      }
      if(this.form.endTime){
        if(this.form.updateCondition == "between" && this.form.endTime.length == 2){
          enterEndTime = {
            begin:this.form.endTime[0],
            end:this.form.endTime[1],
            type:this.form.updateCondition,
            data:'time'

          }
        }else{
          enterEndTime = {
            type:this.form.updateCondition,
            value:this.form.endTime,
            data:'time'
          }
        }
      }
      if(this.form.approvalTime){
        if(this.form.aprovalCondition == "between" && this.form.approvalTime.length == 2){
          approveTime = {
            begin:this.form.approvalTime[0],
            end:this.form.approvalTime[1],
            type:this.form.aprovalCondition,
            data:'time'

          }
        }else{
          approveTime = {
            type:this.form.aprovalCondition,
            value:this.form.approvalTime,
            data:'time'
          }
        }
      }
      if(this.form.createTime){
        if(this.form.createCondition1 == "between" && this.form.createTime.length == 2){
          createTime = {
            begin:this.form.createTime[0],
            end:this.form.createTime[1],
            type:this.form.createCondition1,
            data:'time'
          }
        }else{
          createTime = {
            type:this.form.createCondition1,
            value:this.form.createTime,
            data:'time'
          }
        }
      }
      if(this.form.updateTime){
        if(this.form.updateCondition1 == "between" && this.form.updateTime.length == 2){
          updateTime = {
            begin:this.form.updateTime[0],
            end:this.form.updateTime[1],
            type:this.form.updateCondition1,
            data:'time'
          }
        }else{
          updateTime = {
            type:this.form.updateCondition1,
            value:this.form.updateTime,
            data:'time'
          }
        }
      }
      var params = {
        condition: {
          'factoryId': this.userData.factoryId,
          'performanceInfo.approveStatus':this.form.approveStatus,
          'baseInfo.orderCode':this.form.orderCode,
          'baseInfo.productCode':this.form.productCode,
          'enterProduct.productName':this.form.productName,
          'baseInfo.processCode':this.form.processCode,
          'enterProduct.specs':this.form.specs,
          // orderStatus:this.form.taskStatus,//搞清楚工序状态到底是工序还是任务状态
        },
        currentPage: this.pageparm.currentPage,
        pageSize: this.pageparm.pageSize,
      }
      if(this.form.processName && this.form.processName.length!=0){
        params.condition['enterProcess.processName'] = this.form.processName
      }
      if(this.form.creater && this.form.creater.length!=0){
        params.condition.creater = this.form.creater
      }
      if(this.form.updater && this.form.updater.length!=0){
        params.condition.updater = this.form.updater
      }
      if(JSON.stringify(createTime)!='{}'){
        params.condition.createTime = createTime
      }
      if(JSON.stringify(updateTime)!='{}'){
        params.condition.updateTime = updateTime
      }
      if(this.form.producer && this.form.producer.length!=0){
        params.condition['baseInfo.producer.id'] = this.form.producer;
      }
      if(this.form.approver && this.form.approver.length!=0){
        params.condition['performanceInfo.approver'] = this.form.approver
      }
      if(this.form.countType && this.form.countType.length!=0){
        params.condition['performanceInfo.countType'] = this.form.countType
      }

      if(JSON.stringify(approveTime)!='{}'){
        params.condition['performanceInfo.approveTime'] = approveTime
      }
      if(JSON.stringify(enterStartTime)!='{}'){
        params.condition.enterStartTime = enterStartTime
      }
      if(JSON.stringify(enterEndTime)!='{}'){
        params.condition.enterEndTime = enterEndTime
      }

      if(this.form.planSatrtNum || this.form.planEndNum){
        params.condition.planNum = {
          begin:this.form.planSatrtNum,
          end:this.form.planEndNum,
          type:'between',
          data:'num'
        }
      }
      if(this.form.bestSatrtNum || this.form.bestEndNum){
        params.condition['baseInfo.goodNum'] = {
          begin:this.form.bestSatrtNum,
          end:this.form.bestEndNum,
          type:'between',
          data:'num'
        };
      }
      if(this.form.badSatrtNum || this.form.badEndNum){
        params.condition['baseInfo.nongoodNum'] = {
          begin:this.form.badSatrtNum,
          end:this.form.badEndNum,
          type:'between',
          data:'num'
        }
      }
      if(this.form.unitStartPrice || this.form.unitEndPrice){
        params.condition['performanceInfo.salaryUnit'] = {
          begin:this.form.unitStartPrice,
          end:this.form.unitEndPrice,
          type:'between',
          data:'num'
        }
      }

      if(this.form.estimatedStartSalary || this.form.estimatedEndSalary){
        params.condition['performanceInfo.estimateSalary'] = {
          begin:this.form.estimatedStartSalary,
          end:this.form.estimatedEndSalary,
          type:'between',
          data:'num'
        }
      }
      // var approveTime = this.formateType(this.form.approvalTime)

      // if(JSON.stringify(approveTime)!='{}'){
      //   params.condition.approveTime = approveTime
      // }
      enterGetList(params).then(res => {
        if(res.code == 200){
          this.pageparm.total = res.data.total
          this.listData = res.data.list
        }else{
          this.$message.error('查询失败！')
        }
        this.loading = false
      })
      .catch(err => {
        this.loading = false
        this.$message.error(err)
      })
    },
    formateType(val){
      var approveTime = {}
      if(val == '0'){
        approveTime.type = 'between'
      }else if(val == '1'){
        approveTime.type = 'auto'
      }else if(val == '2'){
        approveTime.type = 'lt'
      }else if(val == '3'){
        approveTime.type = 'lte'
      }else if(val == '4'){
        approveTime.type = 'eq'
      }else if(val == '5'){
        approveTime.type = 'gt'
      }else if(val == '6'){
        approveTime.type = 'gte'
      }
      return approveTime
    },
    /**
     * 监听表格选中项变化事件
     */
    handleTblSelectionChange(val) {
      this.tblSelectionList = val;
      if(this.tblSelectionList.length>0){
        this.isBatchPrint = true;
      }else{
        this.isBatchPrint = false;
      }
    },
    // 分页插件事件
    callFather(parm) {
      this.pageparm.currentPage = parm.currentPage;
      this.pageparm.pageSize = parm.pageSize;
      this.getdata();
    },
    fold() {
      this.isFold = !this.isFold;
    },
    createConditionChange: function(val) {
      this.$set(this.form, "dynamicCreateValue", "");
      this.$set(this.form, val, "");
    },
    updateConditionChange: function(val) {
      this.$set(this.form, "dynamicUpdateValue", "");
      this.$set(this.form, val, "");
    },
    updateApprovalChange: function(val) {
      this.$set(this.form, "approvalValue", "");
      this.$set(this.form, val, "");
    },
    tabClick(tab, event) {
    },
    saveCurrent(){
        this.schemeVisible = true;
    },
    filterScheme(){
        this.filterSchemeVisible = true;
    },
    filterRefresh(val){
      this.tabList = val;
    },
    dynamicCreateValueChange:function(){
      if(this.form.dynamicCreateValue == '7'){
        this.$set(this.form,'dateCreateInput','1')
      }else{
        delete this.form.dateCreateInput
      }
    },
    dateInputCreateBlur:function(){
      if(this.form.dateCreateInput == undefined){
        this.$set(this.form,'dateCreateInput','1')
      }
    },
    // 创建报工
    crateReport(){
      this.modelStatus = 'create'
      this.editRow = {}
      this.mode = 'other'
    },
    // 查看导入日志
    showImportLog() {
      this.mode = 'log'
    },
    handleEdit: function(index, row) {
      this.modelStatus = 'edit'
      this.editRow = row
      this.mode = 'other'
    },
    // handleDelete(index,row){
    //   this.$confirm('确认删除报工？删除后不可恢复!', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }).then(() => {
    //       // const pageLoading = this.openLoading(); //调用方法，打开loading遮罩层
    //       taskDelete(row).then(res => {
    //           if (res.code == 200) {
    //             this.$message({
    //               type: 'success',
    //               message: res.msg
    //             })
    //             this.getdata()
    //           } else {
    //             this.$message({
    //               type: 'error',
    //               message: res.msg
    //             })
    //           }
    //           // pageLoading.close();
    //       }).catch(err => {
    //         // pageLoading.close();
    //         this.$message.error('删除失败，请稍后再试！')
    //       })
    //     }).catch(() => {
    //       this.$message({
    //         type: 'info',
    //         message: '已取消删除'
    //       })
    //     })
    // },
    // 批量操作
    handleCommand(options){
      var selection = this.$refs.tableData.selection
      if(selection.length==0){
        this.$message.warning('请先选择要批量操作的数据')
        return
      }
      if(options == 'delete'){
        this.$confirm('删除后数据无法恢复，确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var idList = selection.map(function(item){return item._id})
          var data = {
            idList:idList
          }
          enterBatchDelete(idList).then(res => {
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: res.msg
                })
                this.getdata()
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              }
            })
          }).catch(err => {
              this.$message.error('删除失败，请稍后再试！')
            })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      }else if(options == 'approval'){
        console.log('selection',selection);
        let flag = false;
        for(let i = 0;i<selection.length;i++){
          if(selection[i].enterOrder.orderStatus == '已结束'){
            flag = true;
            break;
          }
        }
        if(flag){
          this.$message.warning('当前选中项存在已结束工单，无法审批，请重新选择！');
          return;
        }


        this.$confirm('确定批量审批？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var idList = selection.map(function(item){return item._id})
          var data = {
            enterIdList:idList,
            approveStatus:'已审批',
            approver:this.userData.name + '(' + this.userData.account+')',
            approveTime:moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
          }
          reportBatchApproval(data).then(res => {
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: res.msg
                })
                this.getdata()
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              }
            })
          }).catch(err => {
              this.$message.warning('取消操作！')
            })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      }
    },
    done(options){
      this.mode = 'main'
      if(options && options.type == 'save'){
        this.getdata();
        this.printVisible = false;
        this.printTemplateVisible = false;
      }else{
        this.getdata()
        this.printVisible = false;
        this.printTemplateVisible = false;
      }
    },
    goBack(){
      this.mode = 'main'
    },
    handleDelete(index, row) {
      this.$confirm('确认删除报工？删除后不可恢复!', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
          enterDelete(row)
            .then(res => {
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: res.msg
                })
                this.getdata()
              }else{
                this.$message.error(res.msg)
              }
            })
            .catch(err => {
              this.loading = false
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
  }
};
</script>
<style>
.page-top {
  height: 30px;
  line-height: 30px;
}
.el-breadcrumb {
  line-height: 15px;
}
.page-row {
  /* background-color: #efefef; */
}
.page-row .el-tabs__nav-wrap::after {
  height: 0px;
}
.page-row .el-tabs__header {
  margin: 0px;
}

.user-search {
  margin-top: 20px;
}

.el-divider__text {
  padding: 0px 0px;
  font-size: 20px;
  cursor: pointer;
}
.tbl-pagination {
  text-align: right;
}
.tbl-btn {
  width: 100%;
  height: 40px;
  line-height: 40px;
}
.tbl-btn .tbl-btn-right {
  text-align: right;
}
.el-divider--horizontal {
  margin: 10px 0px;
}
.el-form-item {
  margin-bottom: 20px;
}
.search-row .half-width {
  width: calc(100% - 132px);
  margin-left: 8px;
}
.search-row .input-number{
    width: calc(50% - 5px);
}
.search-row{
  display:flex;
  flex-wrap: wrap;
}
</style>



// WEBPACK FOOTER //
// src/views/workReport/WorkReport.vue